import Banner from './Banner';

const FeaturedSeventyFiveTwentyFive = ({ data: { banner, categoria } }) => {
  const bannerListLength = (banner && banner.length) || 0;

  return (
    <div className='container mb-8 md:mb-12'>
      <h3 className='feauteredSevenTwenty-title text-gray-600 mb-3'>{categoria.descripcion}</h3>
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5'>
        {banner
          .sort((a, b) => a.orden - b.orden)
          .map((item, index) => (
            <Banner
              key={item.id}
              data={item}
              className={
                index === 0 && bannerListLength ? 'md:col-span-1 lg:col-span-2 row-span-1' : ''
              }
            />
          ))}
      </div>
    </div>
  );
};

export default FeaturedSeventyFiveTwentyFive;
